import { clsx } from 'clsx';
import Body from '../body/Body.mjs';
import '../common/theme.mjs';
import '../common/direction.mjs';
import '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import '../common/propsValues/size.mjs';
import { Typography } from '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import '@transferwise/icons';
import 'react';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';
import RadioButton from '../common/RadioButton/RadioButton.mjs';

function Radio({
  label,
  id,
  disabled,
  className,
  avatar,
  secondary,
  ...otherProps
}) {
  return /*#__PURE__*/jsx("div", {
    className: clsx('radio np-radio', {
      'radio-lg': secondary,
      'radio-disabled': disabled
    }, className),
    children: /*#__PURE__*/jsxs("label", {
      className: clsx({
        disabled
      }),
      htmlFor: id,
      children: [/*#__PURE__*/jsx("span", {
        className: "m-r-2 np-radio-button",
        children: /*#__PURE__*/jsx(RadioButton, {
          id: id,
          disabled: disabled,
          ...otherProps
        })
      }), /*#__PURE__*/jsxs(Body, {
        as: "span",
        type: secondary ? Typography.BODY_LARGE_BOLD : Typography.BODY_LARGE,
        className: "np-radio__text",
        children: [label, secondary && /*#__PURE__*/jsx(Body, {
          as: "span",
          children: secondary
        })]
      }), avatar && /*#__PURE__*/jsx("span", {
        className: "np-radio__avatar m-l-auto",
        children: avatar
      })]
    })
  });
}

export { Radio as default };
//# sourceMappingURL=Radio.mjs.map
